import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FilterStateService } from '@services/filter-state.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { IconSanitizerService, TabItemComponent, TabViewComponent } from 'ngx-lib';
import { CompaniesFiltersComponent, IFilterValueCompanies } from '../companies-filters/companies-filters.component';
import { CompaniesListComponent } from '../companies-list/companies-list.component';
import { CompaniesMapComponent } from '../companies-map/companies-map.component';

@Component({
    selector: 'app-companies-main',
    templateUrl: './companies-main.component.html',
    styleUrls: ['./companies-main.component.scss'],
    imports: [
        SectionHeaderComponent,
        TabViewComponent,
        TabItemComponent,
        CompaniesFiltersComponent,
        CompaniesListComponent,
        CompaniesMapComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IFilterValueCompanies>
        }
    ]
})
export class CompaniesMainComponent {
    listIcon?: SafeHtml;
    mapIcon?: SafeHtml;
    currentTab: string;
    plusIcon?: SafeHtml;

    constructor(
        private readonly router: Router,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.listIcon = this.iconSanitizer.getIcon('list');
        this.mapIcon = this.iconSanitizer.getIcon('map');
        this.currentTab = 'List';
        this.plusIcon = this.iconSanitizer.getIcon('plus');
    }

    onCreateNewCompanyClicked() {
        this.router.navigate([`/companies-edit`]);
    }
}
